import { Injectable } from '@angular/core';
import { DeviceDetectorService, OrientationType } from 'ngx-device-detector';
import { Observable, ReplaySubject } from 'rxjs';

export interface IScreenOptionsFull {
  isNormalDevice?: boolean;
  isMobileDevice?: boolean;
  isTabletDevice?: boolean;
  isPortrait: boolean;
  isLandscape: boolean;
  isForceDesktop?: boolean; // true даже если мобильник показывать десктопную версию
  isMeeting?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ScreenOptionsService {
  private options$: ReplaySubject<IScreenOptionsFull> =
    new ReplaySubject<IScreenOptionsFull>(1);
  private _options = this.options$.asObservable();

  public set options(options: Observable<IScreenOptionsFull>) {
    options.subscribe((opt) => {
      const newScreenOptions: IScreenOptionsFull = {
        isNormalDevice: opt.isNormalDevice,
        isTabletDevice: opt.isTabletDevice,
        isMobileDevice: opt.isMobileDevice,
        isPortrait: !opt.isForceDesktop && opt.isPortrait,
        isLandscape: !opt.isForceDesktop && opt.isLandscape,
        isForceDesktop: opt.isForceDesktop,
        isMeeting: opt.isMeeting,
      };
      this.options$.next(newScreenOptions);
    });
  }

  public get options(): Observable<IScreenOptionsFull> {
    return this._options;
  }

  public get isSafari(): boolean {
    return (
      !!navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      !!navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1
    );
  }

  private deviceType: 'mobile' | 'desktop' | null = null;

  public setDeviceType(deviceType: 'mobile' | 'desktop'): void {
    this.deviceType = deviceType;
    this.options$.next(this.defaultScreenOptions());
  }

  public defaultScreenOptions(): IScreenOptionsFull {
    const isMobile =
      this.deviceType === 'mobile'
        ? true
        : this.deviceType === 'desktop'
        ? false
        : this.deviceService.isMobile();

    const isNormalDevice =
      this.deviceType === 'desktop'
        ? true
        : this.deviceType === 'mobile'
        ? false
        : this.deviceService.isDesktop() || this.deviceService.isTablet();

    return {
      isNormalDevice,
      isTabletDevice: false,
      isMobileDevice: isMobile,
      isPortrait: this.deviceService.orientation() === OrientationType.Portrait,
      isLandscape: this.deviceService.orientation() === OrientationType.Landscape,
      isForceDesktop: this.deviceType === 'desktop',
      isMeeting: false,
    };
  }

  constructor(public deviceService: DeviceDetectorService) {
    this.options$.next(this.defaultScreenOptions());
  }
}
